export const ActiveIntegration = {
  XERO: 'XERO',
  MYOB: 'MYOB',
  ADVANCE_MYOB: 'ADVANCE_MYOB',
  QUICKBOOK: 'QUICKBOOK',
} as const;

export type IActiveIntegrationType =
  (typeof ActiveIntegration)[keyof typeof ActiveIntegration];

export const EXCLUDED_ACCOUNTING_CODE_TYPES = new Set([
  'REVENUE',
  'SALES',
  'OTHERINCOME',
]);

export const SYNC_STATUS_TOOLTIPS = {
  bill_sync_status: 'Enable auto-sync in settings and resync again',
  purchase_order_sync_status: 'Enable auto-sync in settings and resync again',
  resource_code_sync_status:
    'Item code will be set to None, allow creating an item code to sync',
  supplier_sync_status: '',
  accounting_code_sync_status: '',
  taxcode_sync_status: '',
  job_sync_status: '',
} as const;

export const ERROR_MESSAGE_PREFIXES = {
  supplier_sync_status: 'Missing Suppliers',
  accounting_code_sync_status: 'Missing Accounting Codes',
  bill_sync_status: 'Bills Issue',
  purchase_order_sync_status: 'Purchase Order Issue',
  resource_code_sync_status: 'Resource Code Issue',
  taxcode_sync_status: 'Tax Code Issue',
  job_sync_status: 'Job Issue',
} as const;

export const ERROR_KEY_MAP = {
  supplier_sync_status: 'unavailable_suppliers',
  accounting_code_sync_status: 'unavailable_accountingcodes',
  purchase_order_sync_status: 'unavailable_purchase_orders',
  resource_code_sync_status: 'unavailable_resource_codes',
  bill_sync_status: 'unavailable_bills',
  taxcode_sync_status: 'unavailable_taxcodes',
  job_sync_status: 'unavailable_jobs',
} as const;

const BASE_SYNC = {
  MYOB: 'myob',
  XERO: 'xero',
  MYOB_ADVANCE: 'myob_acumatica',
  QUICKBOOK: 'quickbook',
} as const;

export const PO_SYNC_MSG = Object.freeze({
  MYOB: `${BASE_SYNC.MYOB}_po_sync`,
  XERO: `${BASE_SYNC.XERO}_po_sync`,
  MYOB_ADVANCE: `${BASE_SYNC.MYOB_ADVANCE}_po_sync`,
  QUICKBOOK: `${BASE_SYNC.QUICKBOOK}_po_sync`,
} as const);

export const BILL_SYNC_MSG = Object.freeze({
  MYOB: `${BASE_SYNC.MYOB}_bill_sync`,
  XERO: `${BASE_SYNC.XERO}_bill_sync`,
  MYOB_ADVANCE: `${BASE_SYNC.MYOB_ADVANCE}_bill_sync`,
  QUICKBOOK: `${BASE_SYNC.QUICKBOOK}_bill_sync`,
} as const);

export const PO_SYNC_TYPES = Object.freeze(
  Object.values(PO_SYNC_MSG) as readonly string[],
);

export const defaultQueryConfig = {
  refetchOnWindowFocus: false,
  retry: false,
} as const;

export const SYNC_PROGRESS_MESSAGE =
  'SYNC is in progress, you will receive an email with the sync status';

export interface BillType {
  id: string;
  account_payable_type?: string;
  status?: string;
  sync_data?: {
    sync_status?: string;
    force_retry?: boolean;
    message?: string;
  };
}
